
import { PublicClientApplication } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { Button } from '@mui/material';
import { FormattedMessage } from "react-intl";
import { persistor } from '../../store';
import { styles } from '../../style/style';

export default function LogoutButton() {

    const { instance } = useMsal();
    const accountId = localStorage.getItem("homeAccountId");

    function logoutUser() {
        const config = instance.getConfiguration();
        const myMsal = new PublicClientApplication(config);

        // you can select which account application should sign out
        const logoutRequest = {
            account: myMsal.getAccountByHomeId(accountId),
        };
        persistor.purge();
        myMsal.logoutRedirect(logoutRequest);
    }

    return (
        <Button id="logoutButton" sx={styles.LogoutButton} onClick={logoutUser}><FormattedMessage id='user.logout' defaultMessage='Logout' /></Button>
    )
}
